import { put } from 'redux-saga/effects';
import { appReset } from '../actions/reset';

// 创建Saga Effect
export const createEffect = (fn: Function) => {
    return function* (action: Action.Async): any {
        const { callback } = action;
        try {
            const res = yield fn(action);

            // 成功回调
            if (callback && callback.succeeded) {
                callback.succeeded(res);
            }
        } catch (err) {
            // 错误处理
            const { code } = err;
            if (code === 2000 || code === 2800) yield put(appReset());
            // 失败回调
            if (callback && callback.failed) {
                callback.failed(err);
            }
        }
    };
};
